module.exports = __webpack_public_path__ + "img/46_BF24_adapt_or_die.ee02bc3a.jpg";